<template>
  <div class="comment">
    <waterfall
      :col="col"
      :data="newShowList"
      :width="itemWidth"
      :gutterWidth="gutterWidth"
      @loadmore="loadmore"
    >
      <template>
        <div v-for="item in newShowList" :key="item.id">
          <WaterfallList :isPattingAll="true" :type="2" :data="item" />
        </div>
      </template>
    </waterfall>
    <div class="no-more" v-show="sessionid && !empty">加载中...</div>
    <EmptyList v-show="!sessionid" :style="{ background: 'transparent' }" />
    <div class="no-more" v-show="sessionid && empty">没有更多了</div>
    <!-- 登录弹窗 -->
    <van-overlay :show="openBox" z-index="2000">
      <div class="wrapper" @click.stop>
        <div class="box">
          <p class="text">去登录？</p>
          <div class="btns flex justify-bet">
            <span @click="closeBox">取消</span>
            <span @click="jumpLogin">确定</span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { WaterfallList, EmptyList } from "@/components";
import { getPattingDy } from "@/request/api";
import { getCookie, checkWx, navigate } from "@/pages/index/custom";
import { Toast } from "vant";
import Constants from "@/request/base.default.js";

export default {
  components: {
    WaterfallList,
    EmptyList,
  },
  data() {
    return {
      newShowList: [], // 最新晒照列表
      col: 2, // 瀑布流列数
      page: 1, // 瀑布流分页
      empty: false,
      sessionid: "",
      isLogin: false,
      openBox: false,
    };
  },
  methods: {
    loadmore(index) {
      this.initgetPattingDy();
    },
    // 获取我的订阅
    initgetPattingDy() {
      getPattingDy({
        page: this.page,
        pcount: 8,
      })
        .then((res) => {
          let { data, error_code } = res;
          if (error_code === 0) {
            if (data.length > 0) {
              this.newShowList = this.newShowList.concat(data);
              this.page = this.page + 1;
            } else {
              this.empty = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    jumpLogin() {
      if (checkWx()) {
        wx.miniProgram.navigateTo({ url: "../login/login" });
      } else {
        navigate(
          "",
          Constants.mainURL +
            "/app/user/login?backURL=" +
            encodeURIComponent(window.location.href)
        );
      }
    },
    closeBox() {
      this.openBox = false;
    },
  },
  computed: {
    itemWidth() {
      return Math.floor((document.documentElement.clientWidth - 55) / 2);
    },
    gutterWidth() {
      return 15;
    },
  },
  created() {
    this.sessionid = getCookie(Constants.cookie_key);
    if (this.sessionid) {
      this.initgetPattingDy();
    } else {
      this.openBox = true;
    }
  },
  beforeCreate: function () {
    document.getElementsByTagName("html")[0].style.height = "auto";
    document.getElementsByTagName("body")[0].style.height = "auto";
  },
};
</script>

<style lang="less" scoped>
html,
body {
  height: auto;
  width: auto;
}
.comment {
  background-color: #f8f8f8;
  padding: 4.5rem 20px 20px 20px;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  .no-more {
    text-align: center;
    height: 1.875rem;
    color: #ccc;
    font-size: 14px;
    padding-bottom: 70px;
  }
  .vue-waterfall {
    padding-bottom: 0px;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .box {
    width: 18.4375rem;
    height: auto;
    background-color: #fff;
    border-radius: 16px;
    box-sizing: border-box;
    padding: 1.25rem;
    .text {
      font-size: 14px;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
      text-align: center;
    }
    .btns {
      margin-top: 1.5rem;
      span {
        width: 7.5rem;
        height: 2.75rem;
        line-height: 2.75rem;
        text-align: center;
        border-radius: 100px;
        font-size: 16px;
        font-weight: 400;
        box-sizing: border-box;
      }
      & > span:nth-child(1) {
        color: #222;
        border: 1px solid #eee;
      }
      & > span:nth-child(2) {
        color: #fff;
        background-color: #ff4c67;
      }
    }
  }
}
</style>